import { SmartForm } from "@/shared/form/smart-form";
import Form from "@/shared/form/form";
import { SaveHrSettingsMutationVariables } from "gql/graphql";
import Checkbox from "@/shared/form/checkbox";
import { SubmitButton, SubmitWrapper } from "@/shared/form/button";
import { SAVE_HR_SETTINGS } from "@/modules/global-wizard/features/save-hr-settings/api/save-hr-settings";
import { GET_MODULES_FOR_GLOBAL_WIZARD } from "@/modules/global-wizard/features/setup-module-settings/api/get-modules-for-global-wizard";
import { useTranslations } from "use-intl";
import { useHrSettings } from "@/modules/global-wizard/features/save-hr-settings/model/use-hr-settings";
import InputNumber from "@/shared/form/input-number";
import { useNotification } from "@/shared/feedback/notification";

type FieldsType = SaveHrSettingsMutationVariables;

export function SaveHrSettings() {
  const t = useTranslations("GlobalWizard");
  const { settings } = useHrSettings();
  const notify = useNotification();

  return (
    <SmartForm
      mutation={SAVE_HR_SETTINGS}
      refetchQueries={[GET_MODULES_FOR_GLOBAL_WIZARD]}
      afterSubmit={() => {
        notify?.success({
          message: t("Settings saved"),
        });
      }}
    >
      <Form.Item<FieldsType>
        name={["settings", "useElectronicHRDocumentManagementInRequests"]}
        label={t("Use electronic HR document management in requests")}
        valuePropName={"checked"}
        initialValue={
          settings?.useElectronicHRDocumentManagementInRequests ?? false
        }
      >
        <Checkbox />
      </Form.Item>

      <Form.Item<FieldsType>
        name={["settings", "defaultProbationPeriodMonthCount"]}
        label={t("Default probation period month count")}
        initialValue={settings.defaultProbationPeriodMonthCount}
      >
        <InputNumber min={0} />
      </Form.Item>

      <Form.Item<FieldsType>
        name={[
          "settings",
          "useElectronicHRDocumentManagementInPersonAgreement",
        ]}
        label={t("Use electronic HR document management in person agreement")}
        valuePropName={"checked"}
        initialValue={
          settings?.useElectronicHRDocumentManagementInPersonAgreement ?? false
        }
      >
        <Checkbox />
      </Form.Item>

      <SubmitWrapper>
        <SubmitButton />
      </SubmitWrapper>
    </SmartForm>
  );
}
